import React, { createContext, FC } from 'react';

interface ProviderProps {
  isDateHidden?: boolean;
}

export const TournamentTileDateStateContext = createContext<ProviderProps>({
  isDateHidden: false,
});

export const TournamentTileDateStateProvider: FC<ProviderProps> = ({
  isDateHidden = false,
  children,
}) => {
  return (
    <TournamentTileDateStateContext.Provider value={{ isDateHidden }}>
      {children}
    </TournamentTileDateStateContext.Provider>
  );
};
